import axios from "axios";
import React from "react";

import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

export const websiteBaseUrl = `https://www.abidika.com`;

// export const websiteBaseUrl = `http://localhost:8000`;

export const googleMapApiKey = "AIzaSyD4FggAD9zzFffndE1vpmE40Fnplej9sV4";
export const apiBaseUrl = `${websiteBaseUrl}/api/modules`;

export const TemplateContext = React.createContext("horizontal");


export const replaceUnderLine = (value) => {
  return value.replace(/\//g, '_')
}

export const replaceDash = (value) => {
  return value.replace(/\s+/g, '-')
}

const axiosApiInstance = axios.create({
  baseURL: apiBaseUrl
});


axiosApiInstance.interceptors.request.use(
  (config) => {
    config.headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    };
    return config;
  },
  (error) => {
    removeLoader()
    Promise.reject(error);
  }
);

const removeLoader = () => setTimeout(() => {} , 300)

const toastConfig = {
  position: "bottom-left",
  autoClose: 1000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: false,
  draggable: false,
  progress: undefined,
}

const notifyMessage = (message) => toast.error(message, toastConfig)

export const get = (componentUrl, actionType, data = null) => {
  return function (dispatch) {
    axiosApiInstance.get(componentUrl, { params: data })
      .then((response) => {
        removeLoader()
        if (response.data.error) {
          notifyMessage(response.data.message);
          return false;
        } else {
          dispatch({
            type: actionType,
            payload: response.data
          });
        }
      }).catch(function (error) {
        if (error.response.data.message == "permissionError") {
          window.location.href = "/permission-error"
        }
        if (error.response.data.message == "Unauthenticated.") {
          localStorage.removeItem("token")
          window.location.href = "/"
        }
        removeLoader()
      });
  };
};

export const post = (componentUrl, actionType, formId = "store") => {
  let formData = new FormData(document.getElementById(formId));

  if (formData.get('state') == null) {
    formData.append('state', 'deactive');
  }
  return function (dispatch) {
    axiosApiInstance.post(componentUrl, formData)
      .then((response) => {
        removeLoader()
        if (response.data.error) {
          notifyMessage(response.data.message);
          return false;
        } else {
          dispatch({
            type: actionType,
            payload: response.data
          });
          toast.success("عملیات با موفقیت انجام شد", toastConfig)
        }
      }).catch(function (error) {
        if (error.response.data.message == "permissionError") {
          window.location.href = "/permission-error"
        }
        if (error.response.data.message == "Unauthenticated.") {
          localStorage.removeItem("token")
          window.location.href = "/"
        }
        removeLoader()
      });
  };
};

export const formatNumber = (num) => num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
export const queryToObject = (query) =>
  JSON.parse(
    '{"' + query.substring(1).replace(/&/g, '","').replace(/=/g, '":"') + '"}',
    function (key, value) {
      return key === "" ? value : decodeURIComponent(value);
    }
  );

export const tinyMce = {
  config: {
    height: 500,
    plugins: 'print preview paste importcss searchreplace save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
    rtl_ui: true,
    toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl'
  },
  key: "8jpra1yiyujfo5kd81bkmfvqavvwamokl2jyenodx65tg6x1"
} 